// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3BYEy","emails":"CreateEditClinics_emails__2qOjZ","emailTagLabel":"CreateEditClinics_emailTagLabel__3IedV"};